"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlyoutCatalogBody = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _Tooltip = require("b2b-components/core/components/Tooltip");
var _Icon = require("b2b-components/theme/components/Icon");
var _Tabs = require("b2b-components/theme/components/Tabs");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Flyout = require("../../Flyout");
require("./FlyoutCatalogBody.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var FlyoutCatalogBody = function FlyoutCatalogBody(_ref) {
  var catalog = _ref.catalog,
    className = _ref.className,
    deviceType = _ref.deviceType,
    catalogLinks = _ref.catalogLinks,
    closeFlyout = _ref.closeFlyout,
    onLinkClick = _ref.onLinkClick,
    coreAssortmentTooltipText = _ref.coreAssortmentTooltipText;
  var handleClick = (0, _react.useCallback)(function (category, position) {
    onLinkClick(category, position);
    closeFlyout();
  }, [closeFlyout, onLinkClick]);
  if (!catalog || !Array.isArray(catalog) || catalog.length <= 0) {
    return null;
  }
  var rootClassName = (0, _classnames["default"])('cds-FlyoutCatalogBody', className);
  var renderTabs = function renderTabs() {
    var catalogArray = catalog.map(function (mainCategory, mainIndex) {
      var _mainCategory$childre;
      var label = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "cds-FlyoutCatalogBody-HeaderText"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "cds-FlyoutCatalogBody-HeaderTitle"
      }, mainCategory.title, mainCategory.iconName && /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
        content: mainCategory.tooltipText,
        className: "cds-FlyoutCatalogBody-Tooltip",
        wrapperClassName: "cds-FlyoutCatalogBody-TooltipWrapper",
        triggerClassName: "cds-FlyoutCatalogBody-TooltipTrigger"
      }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
        name: mainCategory.iconName,
        size: _Icon.Icon.config.size.small
      }))), /*#__PURE__*/_react["default"].createElement("span", {
        className: "cds-FlyoutCatalogBody-HeaderSubtitle"
      }, mainCategory.subtitle)), !!((_mainCategory$childre = mainCategory.children) !== null && _mainCategory$childre !== void 0 && _mainCategory$childre.length) && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
        className: "cds-FlyoutCatalogBody-HeaderArrowIcon",
        name: _Icon.ICON_NAME.arrowRight
      }));
      return /*#__PURE__*/_react["default"].createElement(_Tabs.Tab, {
        title: label,
        key: (0, _key.createKey)(mainIndex, mainCategory.title)
      }, /*#__PURE__*/_react["default"].createElement(_Flyout.Flyout.Heading, {
        href: mainCategory.href,
        onClick: function onClick() {
          return handleClick(mainCategory, 1);
        }
      }, mainCategory.title, /*#__PURE__*/_react["default"].createElement("span", {
        className: "cds-FlyoutCatalogBody-TabHeaderSubtitle"
      }, mainCategory.subtitle)), /*#__PURE__*/_react["default"].createElement(_Flyout.Flyout.Body, {
        areColumnsResponsive: true
      }, Array.isArray(mainCategory.children) && mainCategory.children.map(function (subCategory, subIndex) {
        return /*#__PURE__*/_react["default"].createElement(_Flyout.Flyout.LinksGroup, {
          position: subIndex + 1,
          group: subCategory,
          onClick: handleClick,
          coreAssortmentTooltipText: coreAssortmentTooltipText,
          className: "cds-FlyoutCatalogBody-LinksGroup",
          key: subCategory.title
        });
      })));
    });
    var catalogLinksArray = catalogLinks.map(function (link, idx) {
      return /*#__PURE__*/_react["default"].createElement(_Tabs.Tab, {
        key: idx,
        className: (0, _classnames["default"])('cds-CatalogLink', {
          'cds-CatalogLink--First': idx === 0
        }),
        triggerType: _Tabs.TABS_TRIGGER_TYPE.none,
        title: /*#__PURE__*/_react["default"].createElement("a", {
          className: "cds-CatalogLinkTitle",
          href: link.href
        }, link.title, link.iconName && /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
          content: link.tooltipText ? /*#__PURE__*/_react["default"].createElement("span", {
            className: "cds-CatalogLink-TooltipContent"
          }, link.tooltipText) : null,
          className: "cds-CatalogLink-Tooltip",
          wrapperClassName: "cds-CatalogLink-TooltipWrapper",
          triggerClassName: "cds-CatalogLink-TooltipTrigger"
        }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
          name: link.iconName,
          size: _Icon.Icon.config.size.small
        })))
      });
    });
    return [].concat((0, _toConsumableArray2["default"])(catalogArray), (0, _toConsumableArray2["default"])(catalogLinksArray));
  };
  return /*#__PURE__*/_react["default"].createElement(_Tabs.Tabs, {
    className: rootClassName,
    deviceType: deviceType,
    triggerType: _Tabs.TABS_TRIGGER_TYPE.hoverDelayed,
    displayType: _Tabs.TABS_DISPLAY_TYPE.vertical
  }, renderTabs());
};
exports.FlyoutCatalogBody = FlyoutCatalogBody;